import React, { useEffect, useState } from 'react'
import PageHeading from '../../../components/PageHeading'
import FilterTable from '../../../components/FilterTable'
// import GetDealWiseInvestor from '../../../APIs/InvestorPortfolio/GetDealWiseInvestor'
import { Link } from 'react-router-dom'
import Loader from '../../../components/Loader'
// import GetOwnerPortfolio from '../../../APIs/OwnerPortfolio/GetOwnerPortfolio'
import GetOwnerOverviewDetails from '../../../APIs/OwnerPortfolio/GetOwnerOverviewDetails'

const OwnerPortfolio = () => {
    const [ownerTempList, setOwnerTempList] = useState([])
    const [ownerList, setOwnerList] = useState([])

    let [loader, setLoader] = useState(1)

    const loadOwnerOverviewDetails = async () => {
        try {
            const response = await GetOwnerOverviewDetails()
            if (response.status === 1) {
                setOwnerTempList(response.responseValue)
                setOwnerList(response.responseValue)
            }
            else {
                setOwnerTempList([])
                setOwnerList([])
            }
        }
        catch (e) {
            setOwnerTempList([]);
            setOwnerList([]);
        }
        finally {
            setLoader(0);
        }
    }


    useEffect(() => {
        loadOwnerOverviewDetails();
    }, [])

    return (
        <>
            <div className='container-fluid landformconatiner p-4'>
                <div className='d-flex flex-column flex-md-row justify-content-between'>
                    <PageHeading pagename="Investors Portfolio Overview " />
                    <FilterTable tempList={ownerTempList} tempListMethod={setOwnerTempList} originalList={ownerList} isSearch={true} />
                </div>

                <div className='pt-4'>
                    <table className="table">
                        <thead>
                            <tr className='table-head'>
                                <th scope="col">Name</th>
                                <th scope="col">Total Land Area (SqFt)</th>
                                <th scope="col">Investment Status (₹)</th>
                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody className='table-body'>
                            {
                                ownerTempList && ownerTempList.map((val, ind) => {
                                    return (
                                        <tr key={ind}>
                                            <td>
                                                <div className='d-flex flex-row gap-2'>
                                                    <div style={{ width: "30px", height: "30px", backgroundColor: "#E4E4E4", borderRadius: "15px" }}></div>
                                                    <span className='d-flex flex-column gap-1'>
                                                        <label className='heading-project fw-semibold'>{val.ownerName}</label>
                                                    </span>
                                                </div>
                                            </td>
                                            <td>{val.totalLandAreaSqFt}</td>
                                            <td>
                                                <span style={{ color: 'red', marginRight: '10px' }}>{val.investedAmount}</span>
                                                <i className="fa-solid fa-arrow-down" style={{ color: 'red', marginRight: '20px' }}></i>
                                                <span style={{ color: 'green', marginLeft: '10px' }}>{val.givenAmount}</span>
                                                <i className="fa-solid fa-arrow-up" style={{ color: 'green', marginLeft: '5px' }}></i>
                                            </td>
                                            <td >
                                                <div class="dropdown dropend">
                                                    <i class="bi bi-three-dots-vertical " data-bs-toggle="dropdown" aria-expanded="false"></i>
                                                    <ul className="dropdown-menu mr-3">
                                                        <li><Link className="dropdown-item" to={`/ownerportproject/${val?.ownerId}`}>View Details</Link></li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            <Loader show={loader} />

        </>
    )
}

export default OwnerPortfolio
